<cwc-modal open="{{dareminder}}" designVersion="v2" (cwcClose)="dareminderClosed()" id="cmx-modal-reminder">
  <div [innerHtml]="body">
  </div>
</cwc-modal>
